import * as React from "react";
const SvgFiRrDiceD6 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dice-d6_svg__a)">
      <path
        fill="#062147"
        d="m20.572 4.312-6-3.6a4.99 4.99 0 0 0-5.145 0l-6 3.6A5.03 5.03 0 0 0 1 8.6v6.8a5.03 5.03 0 0 0 2.427 4.288l6 3.6a4.98 4.98 0 0 0 5.145 0l6-3.6A5.03 5.03 0 0 0 23 15.4V8.6a5.03 5.03 0 0 0-2.428-4.288M10.457 2.428a2.99 2.99 0 0 1 3.086 0l6 3.6q.247.149.46.341l-8 4.8-8-4.8a3 3 0 0 1 .46-.341zm-6 15.545A3.01 3.01 0 0 1 3 15.4V8.6q0-.24.039-.475L11 12.9v8.928a3 3 0 0 1-.543-.257zM21 15.4a3.02 3.02 0 0 1-1.457 2.573l-6 3.6a3 3 0 0 1-.543.257V12.9l7.961-4.776q.04.237.039.476z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dice-d6_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDiceD6;
